export { default as MailOpenIcon } from './MailOpenIcon';
